import { render, staticRenderFns } from "./Departamento.vue?vue&type=template&id=37fcef2e"
import script from "./Departamento.vue?vue&type=script&lang=js"
export * from "./Departamento.vue?vue&type=script&lang=js"
import style0 from "./Departamento.vue?vue&type=style&index=0&id=37fcef2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports